/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_sports_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy tools and calculators for sports fans.`)
};

const es_cat_sports_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas de fantasy y calculadoras para aficionados al deporte.`)
};

const de_cat_sports_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy-Tools und Rechner für Sportfans.`)
};

const nl_cat_sports_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy tools en rekenmachines voor sportfans.`)
};

const fr_cat_sports_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils fantasy et calculateurs pour les fans de sport.`)
};

const it_cat_sports_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti fantasy e calcolatori per gli appassionati di sport.`)
};

const pt_br2_cat_sports_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas e calculadoras de fantasy para fãs de esportes.`)
};

const pt_cat_sports_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas e calculadoras de fantasy para adeptos de desporto.`)
};

const ja_cat_sports_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スポーツファンのためのファンタジーツールと計算機。`)
};

const zh_cat_sports_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为体育爱好者提供的梦幻工具与计算器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_sports_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_sports_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_sports_desc", locale)
	if (locale === "en") return en_cat_sports_desc(inputs)
	if (locale === "es") return es_cat_sports_desc(inputs)
	if (locale === "de") return de_cat_sports_desc(inputs)
	if (locale === "nl") return nl_cat_sports_desc(inputs)
	if (locale === "fr") return fr_cat_sports_desc(inputs)
	if (locale === "it") return it_cat_sports_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cat_sports_desc(inputs)
	if (locale === "pt") return pt_cat_sports_desc(inputs)
	if (locale === "ja") return ja_cat_sports_desc(inputs)
	return zh_cat_sports_desc(inputs)
};